export const DEFAULT_MAINTENANCE_MESSAGE =
    "LiftOne Now is temporarily offline while we perform some essential maintenance. We're working to get everything back in gear as quickly as possible. If you have an urgent request during this time, please reach out directly to your branch. Thank you for your patience!"
